/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Venue } from '@app/settings/venues/venue.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebsitesService } from '@app/settings/websites/websites.service';
import { VenuesService } from '@app/settings/venues/venues.service';
import { ApiQuery } from '@app/core/http/api-query';

const log = new Logger('VenuesSeoFormComponent');

@Component({
  selector: 'app-venues-seo-form',
  templateUrl: './venues-seo-form.component.html',
  styleUrls: ['./venues-seo-form.component.scss'],
})
export class VenuesSeoFormComponent implements OnInit {
  @Input() venueSeo: Venue = null;
  form: FormGroup;
  companyWebsiteLocales: Array<any>;
  currentWebsiteLocaleId: number;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private websitesService: WebsitesService,
    private venuesService: VenuesService
  ) {}

  ngOnInit() {
    log.debug(this.venueSeo);
    this.createForm();
    this.getData();
  }

  save() {
    log.debug(this.form.get('websiteLocales').value);
    this.venuesService
      .updateTranslations(this.venueSeo, { translations: this.form.get('websiteLocales').value })
      .subscribe((res: any) => {
        this.modal.close(res);
      });
  }

  selectCompanyWebSiteLocale(id: number): void {
    this.currentWebsiteLocaleId = id;
  }

  getWebsiteLocaleName(id: number): string {
    const localeObj = this.companyWebsiteLocales.find((x) => x.id === id);
    return localeObj.website.name + ' ' + localeObj.website.url + ' ' + localeObj.locale.locale;
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      websiteLocales: new FormArray([]),
    });
  }

  private getData() {
    this.websitesService.getLocales().subscribe((websiteLocales: []) => {
      this.companyWebsiteLocales = websiteLocales;
      const formArray: FormArray = new FormArray([]);
      websiteLocales.forEach((websiteLocale: any) => {
        formArray.push(
          new FormGroup({
            company_website_locale_id: new FormControl(websiteLocale.id),
            description: new FormControl(null),
            slug: new FormControl(null),
            meta_title: new FormControl(null),
            meta_description: new FormControl(null),
            how_to_get_by_foot: new FormControl(null),
            how_to_get_by_car: new FormControl(null),
            how_to_get_by_public: new FormControl(null),
            relocated: new FormControl(null),
            video_url: new FormControl(null),
            top: new FormControl(false),
            active: new FormControl(false),
          })
        );
      });
      this.form.setControl('websiteLocales', formArray);

      // Взема информацията от API-то и patch-ва контролите един по един
      const query = new ApiQuery().addIncludes('translations');
      this.venuesService.show(this.venueSeo.id, query).subscribe((venue: Venue) => {
        venue.translations.forEach((translation: any) => {
          this.form.get('websiteLocales')['controls'].forEach((websiteLocaleControl: FormControl) => {
            if (
              translation.company_website_locale_id ===
              Number(websiteLocaleControl.get('company_website_locale_id').value)
            ) {
              websiteLocaleControl.patchValue(translation);
            }
          });
        });
      });
    });
  }
}
